module.exports = __webpack_public_path__ + "static/media/mruganksha_kudake.0efe2a1a.png";